// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"G2-z"};